import { createContext, useContext, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("filata-lang") || "en");
  const setLang = (l) => {
    localStorage.setItem("filata-lang", l);
    setLangState(l);
  };
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangToggle = ({ variant = "light" }) => {
  const { lang, setLang } = useLang();
  const base = variant === "dark" ? "text-bg/60" : "text-ink-soft";
  const active = variant === "dark" ? "text-bg" : "text-ink";
  return (
    <div className={`flex items-center gap-1 font-sans text-xs tracking-[0.15em] ${base}`} data-testid="lang-toggle">
      {["en", "it", "ru", "es"].map((l, i) => (
        <span key={l} className="flex items-center">
          {i > 0 && <span className="mx-1 opacity-40">·</span>}
          <button
            data-testid={`lang-${l}`}
            onClick={() => setLang(l)}
            className={`uppercase transition-colors ${lang === l ? `${active} underline underline-offset-4 decoration-terracotta` : "hover:opacity-80"}`}
          >
            {l}
          </button>
        </span>
      ))}
    </div>
  );
};
